import { SvgIconProps } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'ShareButtonLink' })((theme) => ({
	root: {
		display: 'flex',
		alignItems: 'center',
		gap: 17,
		paddingLeft: 25,
		paddingRight: 25,
		paddingTop: 12,
		paddingBottom: 12
	},
	icon: {
		width: 22
	},
	label: {
		fontSize: 16,
		lineHeight: '24px'
	}
}));

export type ShareButtonLinkProps = {
	Icon: React.ComponentType<SvgIconProps>;
	label?: string;
	classes?: Partial<ReturnType<typeof useStyles>['classes']>
};

export const ShareButtonLink = (props: ShareButtonLinkProps) => {
	const { Icon, label } = props;
	let { classes: styles } = useStyles(undefined, { props });

	return (
		<div className={styles.root}>
			<Icon className={styles.icon} />
			{label && <span className={styles.label}>{label}</span>}
		</div>
	);
};
